import { render, staticRenderFns } from "./proxyRoleList.vue?vue&type=template&id=5a0aab4c&scoped=true"
import script from "./proxyRoleList.vue?vue&type=script&lang=js"
export * from "./proxyRoleList.vue?vue&type=script&lang=js"
import style0 from "./proxyRoleList.vue?vue&type=style&index=0&id=5a0aab4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0aab4c",
  null
  
)

export default component.exports